import "./Footer.css";

import { useContext } from "react";

import { AuthContext } from "../util/api";

export default function Footer() {
    const{theme}  =  useContext(AuthContext);
  return (
    <footer className={`footer ${theme}`}>
      <div className="footer-inner">

        {/* BRAND */}
       
        {/* PRODUCTS */}
       

        {/* COMPANY */}
       

        {/* CONTACT */}
      

      </div>

      {/* DIVIDER */}
      <div className="footer-divider" />

      {/* BOTTOM */}
      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} CenterNut. All rights reserved.</p>
      </div>
    </footer>
  );
}
